<main class="w-full h-full bg-workarea">
  <router-outlet></router-outlet>
</main>
